import Card from '../../../components/base/Card';

export default function MarketSegmentsSection() {
  const segments = [
    {
      title: 'Indústria de Alimentos',
      image: 'https://public.readdy.ai/ai/img_res/0b99d56fbc3f16845f69f6abde552722.jpg',
      icon: 'ri-restaurant-line'
    },
    {
      title: 'Produtos Farmacêuticos',
      image: 'https://readdy.ai/api/search-image?query=Pharmaceutical%20manufacturing%20plant%20with%20clean%20room%20environment%2C%20sterile%20production%20lines%2C%20quality%20control%20laboratory%2C%20medicine%20bottles%2C%20regulatory%20compliance%2C%20white%20coats%2C%20modern%20equipment%2C%20clinical%20setting&width=800&height=600&seq=pharma-industry&orientation=landscape',
      icon: 'ri-capsule-line'
    },
    {
      title: 'Ambientes Controlados',
      image: 'https://static.readdy.ai/image/91b17e0e4c4c5325a19775db74687ed5/35609f7f003f34710cd738f103b0c0d2.png',
      icon: 'ri-test-tube-line'
    },
    {
      title: 'Produtos Veterinários',
      image: 'https://readdy.ai/api/search-image?query=Modern%20animal%20feed%20manufacturing%20facility%2C%20pet%20food%20production%20line%2C%20quality%20control%20laboratory%2C%20veterinary%20products%2C%20industrial%20equipment%2C%20clean%20production%20environment%2C%20feed%20pellets%2C%20professional%20setting&width=800&height=600&seq=feed-factory&orientation=landscape',
      icon: 'ri-heart-pulse-line'
    }
  ];

  return (
    <section className="py-20 bg-crop-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-gilroy font-bold text-crop-black mb-6">
            Segmentos de Mercado Atendidos
          </h2>
          <p className="text-xl font-gilroy text-crop-dark max-w-3xl mx-auto">
            Soluções especializadas de identificação molecular para diferentes setores industriais
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {segments.map((segment, index) => (
            <Card key={index} hover className="group animate-fade-in">
              <div className="text-center">
                <div className="relative mb-6 overflow-hidden rounded-xl">
                  <img
                    src={segment.image}
                    alt={segment.title}
                    className="w-full h-48 object-cover object-top transition-transform duration-300 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-crop-black/20 to-transparent"></div>
                </div>
                
                <div className="w-12 h-12 mx-auto bg-crop-teal/20 rounded-full flex items-center justify-center mb-4">
                  <i className={`${segment.icon} text-2xl text-crop-black`}></i>
                </div>
                
                <h3 className="text-xl font-gilroy font-bold text-crop-black mb-4">
                  {segment.title}
                </h3>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}